import React from 'react';
import {Player} from 'patchwork-player';
import Middle from "Components/Middle";

const story = {
    "id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
    "account_id": "08b6bdef-c3c0-4f42-8015-3b1029a69692",
    "name": "Florida",
    "description": "Our adventures in Florida",
    "public_url": null,
    "created_at": "2022-01-28T10:58:09.000000Z",
    "updated_at": "2022-02-04T10:52:51.000000Z",
    "published_at": null,
    "slides": [
        {
            "id": "2ec940fc-9c36-4336-97b8-7eb01fda961b",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 1,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T10:58:49.000000Z",
            "updated_at": "2022-01-28T10:58:49.000000Z",
            "elements": [
                {
                    "id": "25046b1a-5624-408f-b30e-c0a9f8ec6604",
                    "slide_id": "2ec940fc-9c36-4336-97b8-7eb01fda961b",
                    "type": "image",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 600,
                    "position": 1,
                    "data": {
                        "media_id": "6a3811e4-06d7-417c-8741-ae874fe0d7c3",
                        "src": "https://cdn.trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/6a3811e4-06d7-417c-8741-ae874fe0d7c3/400x600.jpg"
                    },
                    "created_at": "2022-01-28T11:07:40.000000Z",
                    "updated_at": "2022-01-28T11:08:13.000000Z"
                },
                {
                    "id": "bae3a2f2-3009-4f45-8d39-75a8ad2ab162",
                    "slide_id": "2ec940fc-9c36-4336-97b8-7eb01fda961b",
                    "type": "text",
                    "x": 100,
                    "y": 450,
                    "width": 300,
                    "height": 65,
                    "position": 2,
                    "data": {
                        "text": "Proton Therapy",
                        "color": "#4337ca",
                        "styles": [
                            "bold"
                        ],
                        "padding": "20",
                        "alignment": "center",
                        "backgroundColor": "#ffffff"
                    },
                    "created_at": "2022-01-29T15:21:23.000000Z",
                    "updated_at": "2022-02-03T15:05:39.000000Z"
                },
                {
                    "id": "f800684f-693c-4ded-9ee6-cbaf34e562ed",
                    "slide_id": "2ec940fc-9c36-4336-97b8-7eb01fda961b",
                    "type": "text",
                    "x": 100,
                    "y": 515,
                    "width": 50,
                    "height": 30,
                    "position": 3,
                    "data": {
                        "text": "2018",
                        "color": "#ffffff",
                        "fontSize": "10",
                        "backgroundColor": "#4337ca"
                    },
                    "created_at": "2022-01-29T15:28:10.000000Z",
                    "updated_at": "2022-01-29T15:30:42.000000Z"
                }
            ]
        },
        {
            "id": "2da7dca8-29dd-46b5-b96b-5394c5c5c542",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 2,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:08:14.000000Z",
            "updated_at": "2022-01-28T11:08:14.000000Z",
            "elements": [
                {
                    "id": "5497b5d8-c206-4531-a875-4cf66df49d5a",
                    "slide_id": "2da7dca8-29dd-46b5-b96b-5394c5c5c542",
                    "type": "image",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 400,
                    "position": 2,
                    "data": {
                        "media_id": "3d18d534-4e36-4302-88d0-7201bc59708c",
                        "src": "https://cdn.trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/3d18d534-4e36-4302-88d0-7201bc59708c/400x400.jpg"
                    },
                    "created_at": "2022-01-28T11:12:19.000000Z",
                    "updated_at": "2022-01-28T11:13:49.000000Z"
                },
                {
                    "id": "85a24900-12c8-4b8d-805a-40f933187cdb",
                    "slide_id": "2da7dca8-29dd-46b5-b96b-5394c5c5c542",
                    "type": "text",
                    "x": 0,
                    "y": 400,
                    "width": 400,
                    "height": 200,
                    "position": 1,
                    "data": {
                        "text": "During Isla's journey we travelled to Florida for Proton Beam Therapy.",
                        "color": "#ffffff",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:08:26.000000Z",
                    "updated_at": "2022-01-29T15:23:56.000000Z"
                }
            ]
        },
        {
            "id": "f0010684-eb23-49b4-ba1e-4a6f655761bc",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 3,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:13:00.000000Z",
            "updated_at": "2022-01-28T11:13:00.000000Z",
            "elements": [
                {
                    "id": "cdaeae45-e5db-40d1-96b1-ceb6a4e06d0a",
                    "slide_id": "f0010684-eb23-49b4-ba1e-4a6f655761bc",
                    "type": "text",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 600,
                    "position": 1,
                    "data": {
                        "text": "With thanks to LoveOliver, Logan's Fund, Hamish Dear's Warm Hugs, Bens Heroes Trust and Kids Cancer Charity...",
                        "color": "#fafafa",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:14:02.000000Z",
                    "updated_at": "2022-01-29T15:25:25.000000Z"
                }
            ]
        },
        {
            "id": "776683e7-aac8-4ac5-8705-bce23cf8832d",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 4,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:13:56.000000Z",
            "updated_at": "2022-01-28T11:13:56.000000Z",
            "elements": [
                {
                    "id": "0b47f443-de31-4d1b-9725-58d32f0a9cbd",
                    "slide_id": "776683e7-aac8-4ac5-8705-bce23cf8832d",
                    "type": "text",
                    "x": 0,
                    "y": 400,
                    "width": 400,
                    "height": 200,
                    "position": 1,
                    "data": {
                        "text": "We were able to enjoy\nsome quality family time\nin Florida",
                        "color": "#fcfcfc",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:16:28.000000Z",
                    "updated_at": "2022-01-29T15:25:37.000000Z"
                },
                {
                    "id": "57a30f80-ee27-40a8-a3b7-35b0eefd8814",
                    "slide_id": "776683e7-aac8-4ac5-8705-bce23cf8832d",
                    "type": "image",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 400,
                    "position": 2,
                    "data": {
                        "media_id": "20c2df0e-d684-47b4-8356-4ecb29f09772",
                        "src": "https://cdn.trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/20c2df0e-d684-47b4-8356-4ecb29f09772/400x400.jpg"
                    },
                    "created_at": "2022-01-28T11:17:44.000000Z",
                    "updated_at": "2022-01-28T11:18:13.000000Z"
                }
            ]
        },
        {
            "id": "7947fe13-8085-4fc6-a561-a1afd9dc9618",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 5,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:18:17.000000Z",
            "updated_at": "2022-01-28T11:18:17.000000Z",
            "elements": [
                {
                    "id": "a7369922-78cc-4fca-96c6-ddb5c6a2a43b",
                    "slide_id": "7947fe13-8085-4fc6-a561-a1afd9dc9618",
                    "type": "image",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 400,
                    "position": 1,
                    "data": {
                        "media_id": "0fd69430-6781-4ef8-94cc-53ed56db835f",
                        "src": "https://cdn.trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/0fd69430-6781-4ef8-94cc-53ed56db835f/400x400.jpg"
                    },
                    "created_at": "2022-01-28T11:18:31.000000Z",
                    "updated_at": "2022-01-28T11:19:21.000000Z"
                },
                {
                    "id": "bf3e6244-0a1f-4005-80e9-0a0b2df795ec",
                    "slide_id": "7947fe13-8085-4fc6-a561-a1afd9dc9618",
                    "type": "text",
                    "x": 0,
                    "y": 400,
                    "width": 400,
                    "height": 200,
                    "position": 2,
                    "data": {
                        "text": "We made the most of\nour time in Disney World Florida",
                        "color": "#ffffff",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:19:22.000000Z",
                    "updated_at": "2022-01-29T15:24:52.000000Z"
                }
            ]
        },
        {
            "id": "f8e248cf-8f09-4142-a107-a18a1339cfc8",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 6,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:20:36.000000Z",
            "updated_at": "2022-01-28T11:20:36.000000Z",
            "elements": [
                {
                    "id": "2b4df37a-34fd-4416-b852-99fac4f563b8",
                    "slide_id": "f8e248cf-8f09-4142-a107-a18a1339cfc8",
                    "type": "image",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 400,
                    "position": 1,
                    "data": {
                        "media_id": "d490a821-91f2-49c5-9446-45e1e17e75df",
                        "src": "https://cdn.trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/d490a821-91f2-49c5-9446-45e1e17e75df/400x400.jpg"
                    },
                    "created_at": "2022-01-28T11:20:46.000000Z",
                    "updated_at": "2022-01-28T11:21:24.000000Z"
                },
                {
                    "id": "6bdd2900-3452-4965-9701-09d9a76210cd",
                    "slide_id": "f8e248cf-8f09-4142-a107-a18a1339cfc8",
                    "type": "text",
                    "x": 0,
                    "y": 400,
                    "width": 400,
                    "height": 200,
                    "position": 2,
                    "data": {
                        "text": "Legoland Florida",
                        "color": "#ffffff",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:21:24.000000Z",
                    "updated_at": "2022-01-29T15:24:11.000000Z"
                }
            ]
        },
        {
            "id": "091b6d8e-6531-4100-b686-fb6c9f1c9420",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 7,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:22:21.000000Z",
            "updated_at": "2022-01-28T11:22:21.000000Z",
            "elements": [
                {
                    "id": "220f8c39-2e55-41bc-90dc-6ce39144cabe",
                    "slide_id": "091b6d8e-6531-4100-b686-fb6c9f1c9420",
                    "type": "image",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 400,
                    "position": 2,
                    "data": {
                        "media_id": "3502a41d-52ed-4318-9580-5aa29b0bb9d7",
                        "src": "https://cdn.trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/3502a41d-52ed-4318-9580-5aa29b0bb9d7/400x400.jpg"
                    },
                    "created_at": "2022-01-28T11:24:16.000000Z",
                    "updated_at": "2022-01-28T11:24:36.000000Z"
                },
                {
                    "id": "3b033372-9d99-4af1-b5eb-187c43f08e11",
                    "slide_id": "091b6d8e-6531-4100-b686-fb6c9f1c9420",
                    "type": "text",
                    "x": 0,
                    "y": 400,
                    "width": 400,
                    "height": 200,
                    "position": 1,
                    "data": {
                        "text": "...and Jacksonville Zoo",
                        "color": "#ffffff",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:22:25.000000Z",
                    "updated_at": "2022-01-29T15:24:33.000000Z"
                }
            ]
        },
        {
            "id": "203f5e37-3fe8-4588-aed9-68a75ca4b977",
            "story_id": "c34e6ee8-025d-45f8-b9ef-de60a58ef113",
            "position": 8,
            "type": null,
            "data": [],
            "created_at": "2022-01-28T11:24:54.000000Z",
            "updated_at": "2022-01-28T11:24:54.000000Z",
            "elements": [
                {
                    "id": "0591e62c-6552-4276-b305-29248a2b0ae0",
                    "slide_id": "203f5e37-3fe8-4588-aed9-68a75ca4b977",
                    "type": "text",
                    "x": 0,
                    "y": 0,
                    "width": 400,
                    "height": 600,
                    "position": 1,
                    "data": {
                        "text": "We will be forever grateful for the time we were able to enjoy in Florida despite the circumstances for our trip.",
                        "color": "#ffffff",
                        "padding": "20",
                        "backgroundColor": "#4338ca"
                    },
                    "created_at": "2022-01-28T11:24:58.000000Z",
                    "updated_at": "2022-01-29T15:24:17.000000Z"
                }
            ]
        }
    ],
    "og:image": "https://trypatchwork.com/play/patchwork/c34e6ee8-025d-45f8-b9ef-de60a58ef113/3502a41d-52ed-4318-9580-5aa29b0bb9d7/400x400.jpg"
};

export default class TestController extends React.Component {
    render() {
        return <Middle>
            <Player slides={story.slides}/>
        </Middle>
    }
}
